import { render, staticRenderFns } from "./AppShell.vue?vue&type=template&id=c869bcda&"
import script from "./AppShell.vue?vue&type=script&lang=js&"
export * from "./AppShell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports